module.exports = __webpack_public_path__ + "img/sports_sbo.dc6b8793.png";